interface EnvelopeFloatProps {
  style: React.CSSProperties
  delay?: number
}

export function EnvelopeFloat({ style, delay = 0 }: EnvelopeFloatProps) {
  return (
    <div
      style={{
        position: 'absolute',
        animation: `oe-envelope-float 6s ease-in-out ${delay}s infinite`,
        ...style,
      }}
    >
      <svg width="48" height="36" viewBox="0 0 48 36" fill="none" aria-hidden="true">
        <rect x="1" y="1" width="46" height="34" rx="6" fill="white" stroke="#FF6B00" strokeWidth="1.5" opacity="0.5" />
        <path d="M1 5L24 20L47 5" stroke="#FF6B00" strokeWidth="1.5" opacity="0.3" />
      </svg>
    </div>
  )
}
